import { Grid, Typography, Skeleton } from "@mui/material";
import { OrderInfo } from "../shared/orderInfo/types";
import StatusAndDate from "../taskManagement/orderInfo/StatusAndDate";
import { fCurrency } from "../utils/formatNumber";
import { fMonthDayYearSlashNotation } from "../utils/formatTime";

interface Props {
    orderInfo: OrderInfo | null
}
const Order = (props:Props) => {
  const captionSx = { fontSize: { xs: "0.7rem", lg: "0.75rem" } };
  const subtitle1Sx = { fontSize: { xs: "0.85rem", lg: "1rem" } };

  return (
    <Grid
      className="customCard"
      container
      width={320}
      columnSpacing={3}
      rowSpacing={1}
      sx={{
        ml: 0,
        ".MuiTypography-caption": { lineHeight: "0.7rem" },
        "> .MuiGrid-item": { paddingLeft: "0px" },
        "> .MuiGrid-item:nth-child(odd)": { paddingLeft: "0p", paddingRight: "12px" }
      }}
    >
      <Grid item xs={6} style={{ paddingTop: 0 }}>
        <Typography variant="subtitle1" sx={subtitle1Sx}>
          {props.orderInfo?.propertyUse} {!props.orderInfo && <Skeleton />}
        </Typography>
      </Grid>
      <Grid item xs={6} style={{ paddingTop: "0px" }}>
        <Typography variant="subtitle1" sx={subtitle1Sx}>
          {props.orderInfo?.transactionType}
          {!props.orderInfo && <Skeleton />}
        </Typography>
      </Grid>
      {props.orderInfo?.commitmentDate && (
        <Grid item xs={6}>
          <Typography variant="caption" sx={captionSx}>
            Commitment Date
          </Typography>
          <Typography variant="subtitle1" sx={subtitle1Sx}>
            {props.orderInfo?.commitmentDate && fMonthDayYearSlashNotation(props.orderInfo?.commitmentDate)}
            {!props.orderInfo && <Skeleton />}
          </Typography>
        </Grid>
      )}
      {(props.orderInfo?.status || props.orderInfo?.settlementDate) && (
        <Grid item xs={6}>
          {props.orderInfo && <StatusAndDate order={props.orderInfo} />}
          {!props.orderInfo && <Skeleton />}
          {!props.orderInfo && <Skeleton />}
        </Grid>
      )}
      <Grid item xs={6}>
        <Typography variant="caption" sx={captionSx}>
          Purchase Price
        </Typography>
        <Typography variant="subtitle1" sx={subtitle1Sx}>
          {props.orderInfo && fCurrency(props.orderInfo?.salesPrice || 0)}
          {!props.orderInfo && <Skeleton />}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="caption" sx={captionSx}>
          Loan Amount
        </Typography>
        <Typography variant="subtitle1" sx={subtitle1Sx}>
          {(props.orderInfo && props.orderInfo?.loanAmounts.map((l) => fCurrency(l)).join(", ")) || (props.orderInfo && "--")}
          {!props.orderInfo && <Skeleton />}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Order;
